import React from 'react';
import AlertType from '@app/model/alert/AlertType';
import PriceComparisonAlertExecutionFragment
	from '@app/site/secured/rateshopper/rates/alert-execution/fragment/price-comparison/PriceComparisonAlertExecutionFragment';
import CompetitorsPriceRateAlertExecutionFragment
	from '@app/site/secured/rateshopper/rates/alert-execution/fragment/competitors-price-rate/CompetitorsPriceRateAlertExecutionFragment';
import { useSelectedCompanyHotel } from '@app/site/secured/rateshopper/rates/provider/useSelectedCompanyHotel';
import AlertExecution from '@app/model/alert/AlertExecution';
import ParityPriceComparisonAlertExecutionFragment
	from '@app/site/secured/rateshopper/rates/alert-execution/fragment/parity-price-comparison/ParityPriceComparisonAlertExecutionFragment';
import CompetitorsSoldOutAlertExecutionFragment
	from '@app/site/secured/rateshopper/rates/alert-execution/fragment/competitors-sold-out/CompetitorsSoldOutAlertExecutionFragment';


const AlertExecutionFragment: React.FunctionComponent<{
	alertExecution: AlertExecution,
}> = ({ alertExecution }) => {


	const { companyHotel } = useSelectedCompanyHotel();

	if (alertExecution && !!companyHotel) {
		return <>
			{alertExecution.alertOutput.alert.type === AlertType.PRICE_COMPARISON &&
				<PriceComparisonAlertExecutionFragment companyHotel={companyHotel} alertExecution={alertExecution} />}
			{alertExecution.alertOutput.alert.type === AlertType.COMPETITORS_PRICE_RATE &&
				<CompetitorsPriceRateAlertExecutionFragment companyHotel={companyHotel} alertExecution={alertExecution} />}
			{alertExecution.alertOutput.alert.type === AlertType.PARITY_PRICE_COMPARISON &&
				<ParityPriceComparisonAlertExecutionFragment companyHotel={companyHotel} alertExecution={alertExecution} />}
			{alertExecution.alertOutput.alert.type === AlertType.COMPETITORS_SOLD_OUT &&
				<CompetitorsSoldOutAlertExecutionFragment companyHotel={companyHotel} alertExecution={alertExecution} />}
		</>;
	}

	return <></>;
};

export default AlertExecutionFragment;
